module.exports = __webpack_public_path__ + "img/ETFvsCF.34f049fd.png";